import React, { useState, useEffect } from 'react';
import useNodeStore from '../store/useNodeStore';
import useExpertStore from '../store/useExpertStore';
import useContactStore from '../store/useContactStore';
import { NodeService } from '../services/NodeService';
import { DesktopService } from '../services/desktopService';
import { db, auth } from '../lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import useAuthStore from '../store/useAuthStore';
import useConfigStore from '../store/useConfigStore';
import RemoteFileBrowser from './RemoteFileBrowser';
import LocalFileBrowser from './LocalFileBrowser';

const isTauri = () => !!window.__TAURI_INTERNALS__;

// --- Icons ---
const XMarkIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>;
const FolderIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776" /></svg>;
const FolderOpenIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776" /></svg>;
const ExpandIcon = ({ className, open }) => <svg className={`${className} transform transition-transform duration-300 ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>;
const BotIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z" /></svg>;
const TrashIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" /></svg>;
const StarIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.562.562 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" /></svg>;
const ShieldIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" /></svg>;
const UserPlusIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" /></svg>;

const ToggleSwitch = ({ checked, onChange, disabled }) => (
    <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={`${checked ? 'bg-indigo-600 border-indigo-500' : 'bg-[var(--bg-tertiary)] border-[var(--border-strong)]'} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} relative inline-flex h-5 w-9 shrink-0 rounded-full border transition-colors duration-200 ease-in-out focus:outline-none focus:ring-1 focus:ring-indigo-500/50`}
    >
        <span className={`${checked ? 'translate-x-4' : 'translate-x-0'} pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`} />
    </button>
);

/**
 * Unified SpaceDialog for both creating and editing spaces.
 */
const SpaceDialog = ({ open, onClose, parentId = null, mode = 'create', nodeId = null }) => {
    const { experts, fetchExperts } = useExpertStore();
    const { contacts, subscribeToContacts } = useContactStore();
    const { nodes, createNode } = useNodeStore();
    const { aiConfigs } = useConfigStore();
    const localDeviceId = useAuthStore(state => state.localDeviceId);

    // Form State
    const [title, setTitle] = useState('');
    const [expertId, setExpertId] = useState('');
    const [modelConfigId, setModelConfigId] = useState('');
    const [desktopEnabled, setDesktopEnabled] = useState(false);
    const [targetDeviceId, setTargetDeviceId] = useState('');
    const [devices, setDevices] = useState([]);
    const [path, setPath] = useState('');
    const [members, setMembers] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [instructionFileIds, setInstructionFileIds] = useState([]);

    // UI State
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const [browseOpen, setBrowseOpen] = useState(false);

    useEffect(() => {
        if (open) {
            fetchExperts();
            const unsub = subscribeToContacts();

            // Load devices
            const uid = auth.currentUser?.uid;
            if (uid) {
                DesktopService.getUserDevices(uid).then(setDevices).catch(console.error);
            }

            if (mode === 'edit' && nodeId) {
                loadNodeData(nodeId);
            } else {
                // Reset for create
                setTitle('');
                setExpertId('');
                setModelConfigId(aiConfigs?.defaultConfigId || '');
                setDesktopEnabled(isTauri());
                setTargetDeviceId(localDeviceId || '');
                setPath('');
                setMembers([]);
                const uid = auth.currentUser?.uid;
                setAdmins(uid ? [uid] : []);
                setInstructionFileIds([]);

                // If we have a parent, try to inherit settings
                if (parentId) {
                    loadParentSettings(parentId);
                }
            }

            return () => unsub && unsub();
        }
    }, [open, mode, nodeId]);

    const loadNodeData = async (id) => {
        setLoading(true);
        try {
            const node = await NodeService.getNode(id);
            if (node) {
                setTitle(node.title || '');
                setExpertId(node.settings?.expertId || '');
                setModelConfigId(node.settings?.modelConfigId || '');
                setDesktopEnabled(node.settings?.desktopEnabled || false);
                setTargetDeviceId(node.settings?.targetDeviceId || localDeviceId || '');
                setPath(node.settings?.path || '');
                setMembers(node.members || []);
                setAdmins(node.admins || []);
                setInstructionFileIds(node.settings?.instructionFileIds || []);
            }
        } catch (err) {
            console.error("Failed to load node:", err);
        } finally {
            setLoading(false);
        }
    };

    const loadParentSettings = async (pId) => {
        setLoading(true);
        try {
            const parent = await NodeService.getNode(pId);
            if (parent && parent.settings) {
                // Inherit desktop settings
                setDesktopEnabled(parent.settings.desktopEnabled || false);
                setTargetDeviceId(parent.settings.targetDeviceId || localDeviceId || '');
                setPath(parent.settings.path || '');

                // Explicitly inherit agent/model
                if (parent.settings.expertId) {
                    setExpertId(parent.settings.expertId);
                } else {
                    setExpertId('');
                }

                if (parent.settings.modelConfigId) {
                    setModelConfigId(parent.settings.modelConfigId);
                } else {
                    // If parent has no model set, use system default
                    setModelConfigId(aiConfigs?.defaultConfigId || '');
                }
            }
        } catch (err) {
            console.error("Failed to load parent settings:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        if (!title.trim()) return;
        setIsSaving(true);
        try {
            const settings = {
                expertId: expertId || null,
                modelConfigId: modelConfigId || null,
                desktopEnabled,
                targetDeviceId: desktopEnabled ? (targetDeviceId || null) : null,
                path: path.trim() || null,
                instructionFileIds
            };

            if (mode === 'create') {
                await createNode(title.trim(), parentId, settings, members);
            } else {
                await NodeService.updateNodeTitle(nodeId, title.trim());
                await NodeService.updateNodeSettings(nodeId, settings);
                await NodeService.updateNodeMembers(nodeId, members);
                await NodeService.updateNodeAdmins(nodeId, admins);
            }
            onClose();
        } catch (err) {
            console.error("Save space error:", err);
            alert("Failed to save space settings.");
        } finally {
            setIsSaving(false);
        }
    };

    const handleDelete = async () => {
        if (!window.confirm(`Are you sure you want to delete "${title}"? This action cannot be undone.`)) return;
        setIsSaving(true);
        try {
            await NodeService.deleteNode(nodeId);
            onClose();
        } catch (err) {
            console.error("Delete node error:", err);
            alert("Failed to delete space.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/20 dark:bg-black/60 backdrop-blur-sm transition-opacity duration-500" onClick={onClose} />

            <div className="relative w-full max-w-lg bg-[var(--bg-secondary)] border border-[var(--border-strong)] rounded-[2.5rem] shadow-2xl overflow-hidden flex flex-col max-h-[85vh]">

                {/* Header */}
                <div className="px-10 py-8 flex items-center justify-between border-b border-[var(--border-subtle)]">
                    <div>
                        <h2 className="text-2xl font-semibold text-[var(--text-main)] tracking-tight">
                            {mode === 'edit' ? 'Space Settings' : 'New Space'}
                        </h2>
                        <p className="text-[13px] text-[var(--text-muted)] mt-1">
                            {mode === 'edit' ? 'Configure your workspace parameters.' : 'Create a dedicated environment for your project.'}
                        </p>
                    </div>
                    <button onClick={onClose} className="p-2.5 rounded-full bg-[var(--bg-tertiary)] text-[var(--text-muted)] hover:text-[var(--text-main)] transition-all">
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto px-10 pb-10 custom-scrollbar">
                    <div className="space-y-8">

                        {/* NAME */}
                        <div className="space-y-3">
                            <label className="block text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-widest ml-1">Space Name</label>
                            <input
                                autoFocus
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder="e.g., Project Alpha"
                                className="w-full bg-[var(--bg-tertiary)] border border-[var(--border-strong)] text-[var(--text-main)] text-[14px] rounded-2xl px-5 py-3.5 outline-none focus:border-[var(--text-muted)]/30 transition-all placeholder-[var(--text-dim)]"
                            />
                        </div>

                        {/* CONFIGURATION GRID */}
                        <div className="grid grid-cols-2 gap-6">
                            {/* AGENT SELECTION */}
                            <div className="space-y-3">
                                <label className="block text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-widest ml-1">Assigned Agent</label>
                                <div className="relative">
                                    <BotIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]" />
                                    <select
                                        value={expertId}
                                        onChange={(e) => setExpertId(e.target.value)}
                                        className="w-full bg-[var(--bg-tertiary)] border border-[var(--border-strong)] text-[var(--text-main)] text-[14px] rounded-2xl pl-11 pr-4 py-3.5 outline-none focus:border-[var(--text-muted)]/30 appearance-none transition-all cursor-pointer"
                                    >
                                        <option value="">No Agent</option>
                                        {experts.map(exp => <option key={exp.id} value={exp.id}>{exp.name}</option>)}
                                    </select>
                                </div>
                            </div>

                            {/* MODEL SELECTION */}
                            <div className="space-y-3">
                                <label className="block text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-widest ml-1">AI Model</label>
                                <div className="relative">
                                    <StarIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]" />
                                    <select
                                        value={modelConfigId}
                                        onChange={(e) => setModelConfigId(e.target.value)}
                                        className="w-full bg-[var(--bg-tertiary)] border border-[var(--border-strong)] text-[var(--text-main)] text-[14px] rounded-2xl pl-11 pr-4 py-3.5 outline-none focus:border-[var(--text-muted)]/30 appearance-none transition-all cursor-pointer"
                                    >
                                        {Object.entries(aiConfigs.configs).map(([id, config]) => (
                                            <option key={id} value={id}>{config.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* MEMBERSHIP SECTION */}
                        <div className="space-y-5 bg-[var(--bg-main)]/50 dark:bg-[var(--bg-tertiary)]/30 border border-[var(--border-strong)] rounded-3xl p-6">
                            <div className="flex items-center justify-between">
                                <h3 className="text-xs font-semibold text-[var(--text-main)] flex items-center gap-2">
                                    <ShieldIcon className="w-4 h-4 text-emerald-500" />
                                    Shared With
                                </h3>
                            </div>

                            <div className="space-y-4">
                                <div className="relative">
                                    <UserPlusIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]" />
                                    <select
                                        value=""
                                        onChange={(e) => {
                                            if (e.target.value && !members.includes(e.target.value)) {
                                                setMembers([...members, e.target.value]);
                                            }
                                        }}
                                        className="w-full bg-[var(--bg-tertiary)] border border-[var(--border-strong)] text-[var(--text-muted)] text-xs rounded-xl pl-11 pr-4 py-2.5 outline-none focus:border-[var(--text-muted)]/30 appearance-none transition-all cursor-pointer"
                                    >
                                        <option value="" disabled>Add Member...</option>
                                        {contacts.filter(c => !members.includes(c.uid)).map(c => (
                                            <option key={c.uid} value={c.uid}>{c.displayName || c.email}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="flex flex-wrap gap-3">
                                    {members.map(uid => {
                                        const c = contacts.find(contact => contact.uid === uid);
                                        const isAdminMember = admins.includes(uid);
                                        const displayName = c?.displayName || c?.email || uid;
                                        const initials = displayName.charAt(0).toUpperCase();

                                        return (
                                            <div key={uid} className="relative group">
                                                <div
                                                    className={`w-10 h-10 rounded-full flex items-center justify-center text-[var(--text-main)] font-bold text-xs border-2 transition-all duration-300 shadow-sm overflow-hidden ${isAdminMember ? 'border-yellow-500 shadow-[0_0_10px_rgba(234,179,8,0.2)] bg-[var(--bg-tertiary)]' : 'border-[var(--border-strong)] bg-[var(--bg-tertiary)]/50'}`}
                                                    title={displayName}
                                                >
                                                    {c?.photoURL ? (
                                                        <img src={c.photoURL} alt={displayName} className="w-full h-full object-cover" />
                                                    ) : (
                                                        <span>{initials}</span>
                                                    )}
                                                </div>

                                                {/* Hover Reveal Remove Button */}
                                                <button
                                                    onClick={() => setMembers(members.filter(m => m !== uid))}
                                                    className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all scale-75 group-hover:scale-100 shadow-lg border border-red-600 z-10"
                                                    title={`Remove ${displayName}`}
                                                >
                                                    <XMarkIcon className="w-3 h-3" />
                                                </button>

                                                {/* Hover Name Tooltip (Subtle) */}
                                                <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 px-2 py-1 bg-[var(--bg-elevated)] text-[var(--text-main)] text-[9px] font-bold uppercase tracking-wider rounded border border-[var(--border-subtle)] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all pointer-events-none shadow-xl z-20">
                                                    {displayName}
                                                </div>
                                            </div>
                                        );
                                    })}
                                    {members.length === 0 && <p className="text-[11px] text-[var(--text-muted)] italic ml-1">Private (Only you can see this).</p>}
                                </div>
                            </div>
                        </div>

                        {/* AI INSTRUCTIONS SECTION */}
                        <div className="space-y-5 bg-[var(--bg-main)]/50 dark:bg-[var(--bg-tertiary)]/30 border border-[var(--border-strong)] rounded-3xl p-6">
                            <div className="flex items-center justify-between">
                                <h3 className="text-xs font-semibold text-[var(--text-main)] flex items-center gap-2">
                                    <BotIcon className="w-4 h-4 text-indigo-500" />
                                    AI Instruction Documents
                                </h3>
                            </div>

                            <p className="text-[11px] text-[var(--text-muted)]">
                                Attach markdown files to guide the AI's behavior and knowledge in this Space.
                            </p>

                            <div className="space-y-4">
                                <div className="relative">
                                    <FolderIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]" />
                                    <select
                                        value=""
                                        onChange={(e) => {
                                            if (e.target.value && !instructionFileIds.includes(e.target.value)) {
                                                setInstructionFileIds([...instructionFileIds, e.target.value]);
                                            }
                                        }}
                                        className="w-full bg-[var(--bg-tertiary)] border border-[var(--border-strong)] text-[var(--text-muted)] text-xs rounded-xl pl-11 pr-4 py-2.5 outline-none focus:border-[var(--text-muted)]/30 appearance-none transition-all cursor-pointer"
                                    >
                                        <option value="" disabled>Add Instruction File...</option>
                                        {/* Filtering for nodes within this Space (or its children) would be ideal, but for now we'll show nodes the user is a member of */}
                                        {nodes.filter(n => !instructionFileIds.includes(n.id) && n.id !== nodeId).map(n => (
                                            <option key={n.id} value={n.id}>{n.title}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="space-y-2">
                                    {instructionFileIds.map(fid => {
                                        const nodeInfo = nodes.find(n => n.id === fid);
                                        return (
                                            <div key={fid} className="flex items-center justify-between p-3 rounded-xl bg-[var(--bg-tertiary)] border border-[var(--border-strong)] group">
                                                <div className="flex items-center gap-3">
                                                    <div className="w-8 h-8 rounded-lg bg-indigo-500/10 flex items-center justify-center">
                                                        <svg className="w-4 h-4 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2.008 0 01-2-2.008V5.008C5 3.9 5.9 3 7.008 3h10.984C19.1 3 20 3.9 20 5.008V18.1a2.9 2.9 0 01-2.9 2.9z" /></svg>
                                                    </div>
                                                    <span className="text-sm text-[var(--text-main)] truncate max-w-[200px] font-medium">
                                                        {nodeInfo?.title || "Unknown File"}
                                                    </span>
                                                </div>
                                                <button
                                                    onClick={() => setInstructionFileIds(instructionFileIds.filter(id => id !== fid))}
                                                    className="p-1.5 opacity-0 group-hover:opacity-100 text-[var(--text-muted)] hover:text-red-400 transition-all rounded-lg"
                                                >
                                                    <TrashIcon className="w-3.5 h-3.5" />
                                                </button>
                                            </div>
                                        );
                                    })}
                                    {instructionFileIds.length === 0 && (
                                        <p className="text-[11px] text-[var(--text-dim)] italic ml-1">No instruction files attached.</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* DESKTOP INTEGRATION */}
                        <div className="space-y-5 bg-[var(--bg-main)]/50 dark:bg-[var(--bg-tertiary)]/30 border border-[var(--border-strong)] rounded-3xl p-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h3 className="text-xs font-semibold text-[var(--text-main)] flex items-center gap-2">
                                        🖥️ Desktop Intelligence
                                    </h3>
                                    <p className="text-[11px] text-[var(--text-muted)] mt-1">Allow AI to interact with your local files.</p>
                                </div>
                                <ToggleSwitch checked={desktopEnabled} onChange={setDesktopEnabled} />
                            </div>

                            {desktopEnabled && (
                                <div className="space-y-4 pt-2 animate-in fade-in slide-in-from-top-2 duration-300">
                                    <div className="space-y-2">
                                        <p className="text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-widest ml-1">Target Device</p>
                                        <div className="relative">
                                            <select
                                                value={targetDeviceId}
                                                onChange={(e) => setTargetDeviceId(e.target.value)}
                                                className="w-full bg-[var(--bg-tertiary)] border border-[var(--border-strong)] text-[var(--text-main)] text-[13px] rounded-xl px-4 py-3 outline-none focus:border-[var(--text-muted)]/30 appearance-none transition-all cursor-pointer"
                                            >
                                                <option value="">Choose a connected machine...</option>
                                                {devices.map(d => {
                                                    const lastSeen = d.last_seen?.toDate ? d.last_seen.toDate().getTime() : 0;
                                                    const isOnline = (Date.now() - lastSeen) < 60000;
                                                    return (
                                                        <option key={d.id} value={d.id}>
                                                            {isOnline ? '🟢 ' : '⚫️ '} {d.computerName || d.id}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-[var(--text-muted)] opacity-40">
                                                <ExpandIcon className="w-4 h-4" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-3">
                                        <label className="block text-[10px] font-bold text-[var(--text-muted)] uppercase tracking-widest ml-1">System Path</label>
                                        <div className="flex gap-2">
                                            <input
                                                type="text"
                                                value={path}
                                                onChange={(e) => setPath(e.target.value)}
                                                className="flex-1 bg-[var(--bg-tertiary)] border border-[var(--border-strong)] text-[var(--text-main)] text-sm rounded-xl px-4 py-2.5 outline-none focus:border-[var(--text-muted)]/30 font-mono transition-all placeholder-[var(--text-dim)]"
                                                placeholder="/Users/omni/work"
                                            />
                                            <button
                                                onClick={() => setBrowseOpen(true)}
                                                className="px-4 py-2.5 bg-[var(--bg-tertiary)] hover:bg-[var(--bg-elevated)] text-[var(--text-main)] text-[12px] font-bold rounded-xl transition-all flex items-center gap-2 border border-[var(--border-strong)]"
                                            >
                                                <FolderOpenIcon className="w-4 h-4" /> Browse
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Footer Actions */}
                <div className="px-10 py-8 bg-[var(--bg-main)]/30 dark:bg-[var(--bg-tertiary)]/10 border-t border-[var(--border-subtle)] flex items-center justify-between">
                    {mode === 'edit' ? (
                        <button
                            onClick={handleDelete}
                            disabled={isSaving}
                            className="flex items-center gap-2 px-5 py-3 text-red-500 hover:text-red-600 hover:bg-red-500/10 rounded-2xl transition-all font-medium text-sm"
                        >
                            <TrashIcon className="w-4 h-4" />
                            Delete Space
                        </button>
                    ) : <div />}

                    <div className="flex items-center gap-3">
                        <button
                            onClick={onClose}
                            className="px-6 py-3 text-sm font-semibold text-[var(--text-muted)] hover:text-[var(--text-main)] transition-all"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            disabled={isSaving || !title.trim()}
                            className="px-8 py-3.5 bg-[var(--accent-primary)] text-[var(--bg-secondary)] hover:bg-[var(--accent-hover)] disabled:opacity-50 disabled:cursor-not-allowed text-sm font-bold rounded-[1.25rem] transition-all shadow-xl shadow-[var(--accent-primary)]/10 flex items-center gap-2"
                        >
                            {isSaving ? (
                                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
                            ) : null}
                            {mode === 'edit' ? 'Save Changes' : 'Create Space'}
                        </button>
                    </div>
                </div>
            </div>

            {/* Browser Sub-Modal */}
            {browseOpen && (
                <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-black/40 backdrop-blur-xl animate-in fade-in duration-300" onClick={() => setBrowseOpen(false)}>
                    <div className="bg-[var(--bg-secondary)] border border-[var(--border-strong)] rounded-[2.5rem] w-full max-w-4xl h-[80vh] flex flex-col overflow-hidden shadow-2xl animate-in zoom-in-95 duration-400" onClick={e => e.stopPropagation()}>
                        <div className="px-10 py-6 border-b border-[var(--border-subtle)] flex items-center justify-between bg-[var(--bg-main)]/30 backdrop-blur-xl">
                            <div className="space-y-1">
                                <h2 className="text-xl font-bold text-[var(--text-main)] tracking-tight">Select Directory</h2>
                                <p className="text-[10px] text-[var(--text-muted)] font-bold uppercase tracking-widest opacity-60">Connect your workspace</p>
                            </div>
                            <button onClick={() => setBrowseOpen(false)} className="p-3 rounded-2xl text-[var(--text-muted)] hover:text-red-400 hover:bg-red-500/5 transition-all outline-none group">
                                <XMarkIcon className="w-6 h-6 group-active:scale-90 transition-transform" />
                            </button>
                        </div>
                        <div className="flex-1 overflow-hidden bg-transparent">
                            {isTauri() ? (
                                <LocalFileBrowser
                                    initialPath={path}
                                    onSelect={(selectedPath) => {
                                        setPath(selectedPath);
                                        setBrowseOpen(false);
                                    }}
                                    onCancel={() => setBrowseOpen(false)}
                                />
                            ) : (
                                <RemoteFileBrowser
                                    userId={auth.currentUser?.uid}
                                    targetDeviceId={targetDeviceId}
                                    initialPath={path}
                                    onSelect={(selectedPath) => {
                                        setPath(selectedPath);
                                        setBrowseOpen(false);
                                    }}
                                    onCancel={() => setBrowseOpen(false)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SpaceDialog;
